export interface LevelBand {
  label: string;
  upper: number | null;
}

const TOP_BAND: LevelBand = { label: 'A', upper: null };

export const LEVEL_BANDS: readonly LevelBand[] = [
  { label: 'D', upper: 1.5 },
  { label: 'D+', upper: 2.2 },
  { label: 'C', upper: 3.2 },
  { label: 'C+', upper: 5 },
  { label: 'B', upper: 6.5 },
  { label: 'B+', upper: 7.5 },
  TOP_BAND,
];

export const RATING_MIN = 0;
export const RATING_MAX = 8;
export const LEVEL_STEPS: readonly number[] = Array.from(
  { length: RATING_MAX - RATING_MIN + 1 },
  (_, i) => RATING_MIN + i,
);

const ru = (n: number): string => String(n).replace('.', ',');

export const bandOfLevel = (level: number): LevelBand =>
  LEVEL_BANDS.find((b) => b.upper !== null && level <= b.upper) ?? TOP_BAND;

export const levelStepLabel = (level: number): string =>
  `${level.toFixed(1)} · ${bandOfLevel(level).label}`;

export const levelBandsText = (): string => {
  let below = 0;
  return LEVEL_BANDS.map((b) => {
    const text = b.upper === null ? `${b.label} выше ${ru(below)}` : `${b.label} до ${ru(b.upper)}`;
    below = b.upper ?? below;
    return text;
  }).join(' · ');
};
